import React, { useState } from "react";
import MenuEditOptionsPanel from "../../common/MenuEditOptionsPanel";
import ManaConfirmDialog from "../../common/dialog/ManaConfirmDialog";
import { cloneDeep } from "lodash";
import IntegrationsHelper, { INTEGRATION_KEYS } from "../IntegrationsHelper";
import DeviceRenameDialog from "./DeviceRenameDialog";

export default function AccountMenuOptions({
  controller,
  account,
  accounts,
  integrationName,
  disconnectAccount = () => {},
  close = () => {},
}) {
  const [accountToDelete, setAccountToDelete] = useState(null);
  const [deviceToRename, setDeviceToRename] = useState(null);

  // ------------------------------------- OBSERVERS -------------------------------------
  const getMenuOptions = (acc) => {
    const options = [
      {
        text: acc.isAutoTracked ? "Stop Autotracking" : "Start Autotracking",
        action: toggleAutoTracking,
      },
    ];

    if (integrationName == INTEGRATION_KEYS.desktop) {
      options.push({
        text: "Rename Device Alias",
        action: selectDeviceToRename,
      });
    }

    if (acc.isEnabled) {
      options.push({
        text: "Delete All Integration Data",
        action: deleteAllIntegrationsData,
        isDelete: true,
      });
    }
    options.push({
      text: "Disconnect Account",
      action: disconnect,
      isDelete: true,
    });

    return options;
  };

  const toggleAutoTracking = () => {
    const isAutoTracked = !account.isAutoTracked;
    (accounts || []).forEach((a) => {
      if (a.id == account.id) {
        a.isAutoTracked = isAutoTracked;
      }
    });

    IntegrationsHelper.saveIntegrationSource(controller, {
      [`autotrack_${integrationName}`]: isAutoTracked,
      account: account.email,
      id: account.id,
      isAutoTracked: isAutoTracked,
    });

    close();
  };

  const selectDeviceToRename = () => {
    setDeviceToRename(cloneDeep(account));
  };

  const renameDevice = (name) => {
    if (!name) return;

    account.name = name;
    setDeviceToRename(null);
    close();

    controller.cardActionWithCallback({
      action: "save",
      target: "integration_source",
      id: account.id,
      name: name,
    });
  };

  const disconnect = () => {
    close();
    disconnectAccount(account);
  };

  const deleteAllIntegrationsData = () => {
    toggleDeleteDialog(cloneDeep(account));
    close();
  };

  const toggleDeleteDialog = (acc) => {
    setAccountToDelete(acc);
  };

  const confirmedDelete = () => {
    if (!accountToDelete) return;
    toggleDeleteDialog(null);

    controller.tracking.track("Delete integration");
    controller.cardActionWithCallback(
      {
        action: "save",
        target: "integration_data",
        operation: "delete-all",
        id: accountToDelete.id,
      },
      () => {
        controller.cardAction({ action: "refresh" });
      },
    );
  };

  return (
    <>
      <DeviceRenameDialog
        controller={controller}
        device={deviceToRename}
        onClose={() => setDeviceToRename(null)}
        rename={renameDevice}
      />

      {account && !deviceToRename ? (
        <MenuEditOptionsPanel
          isPanelActive={true}
          close={close}
          options={getMenuOptions(account)}
        />
      ) : null}

      {accountToDelete ? (
        <ManaConfirmDialog
          isOpen={true}
          title="Are you sure?"
          description={`Tapping delete will erase all received data for this integration.
      PLEASE BE VERY CAREFUL, THERE IS NO UNDO FOR THIS ACTION.`}
          onConfirm={confirmedDelete}
          onClose={() => toggleDeleteDialog(null)}
          confirmText="Delete"
          confirmTextColor="#DD5F43"
        />
      ) : null}
    </>
  );
}
